/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aitextbutton2Inputs */

const en_aitextbutton2 = /** @type {(inputs: Aitextbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI text`)
};

const de_aitextbutton2 = /** @type {(inputs: Aitextbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Text`)
};

/**
* | output |
* | --- |
* | "AI text" |
*
* @param {Aitextbutton2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aitextbutton2 = /** @type {((inputs?: Aitextbutton2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aitextbutton2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aitextbutton2(inputs)
	return de_aitextbutton2(inputs)
});
export { aitextbutton2 as "aiTextButton" }